var React = require('react');

function Catering (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M934.95,644.79c-2.66-46.65-12.8-91.96-30.24-135.01-19.86-49.03-48.31-93.07-84.55-130.9-36.31-37.91-78.63-67.69-125.78-88.5-41.25-18.21-84.67-28.85-129.38-31.74v-19.75h39.67v-50h-129.33v50h39.67v19.75c-44.71,2.88-88.13,13.52-129.38,31.74-47.14,20.82-89.46,50.59-125.78,88.5-36.24,37.83-64.69,81.88-84.55,130.9-17.44,43.05-27.58,88.36-30.24,135.01h-52.1v50h894.11v-50h-52.1ZM540,307.84c182.58,0,332.54,148.99,344.84,336.95H195.16c12.3-187.96,162.27-336.95,344.84-336.95Z","key":0}),React.createElement("rect",{"x":"148.5","y":"745.33","width":"783","height":"50","key":1})]);
}

Catering.defaultProps = {"id":"ICONS","width":"15in","height":"15in","version":"1.1","viewBox":"0 0 1080 1080"};

module.exports = Catering;

Catering.default = Catering;
